import factoryStore from '../components/factory-store'

const projectCouncil = {
  ...factoryStore('ProjectCouncil'),
}

const projectCouncilStore = {
  ...projectCouncil,
}

export default projectCouncilStore
